import { useTranslation } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import React, { useState } from "react";

function ImportSignature({ handleSignDocChange, acceptFileType }: any) {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState<any>(false);

  const fileToBase64 = async (file: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });

  const importFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e?.target?.files?.[0];

    if (file) {
      const base64ImageStr = await fileToBase64(file);
      const fileType = file.type;

      setSelectedFile(file);
      handleSignDocChange({ base64ImageStr, fileType });
    }
  };

  return (
    <div>
      <label htmlFor="signatureImage">
        <input
          type="file"
          name="signDoc"
          id="signatureImage"
          className="hidden"
          accept={acceptFileType ?? "image/png,image/jpg,image/jpeg,application/pdf"}
          onChange={importFile}
        />

        <div className="relative flex items-center justify-between gap-4 border border-[#c6d0df] px-4 py-2 cursor-pointer">
          <div className="pointer-events-none">
            <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>{t("Choose File")}</ButtonComponent>
          </div>
          <span className="text-sm">{!selectedFile ? "No File Chosen" : selectedFile.name}</span>
        </div>
      </label>
    </div>
  );
}

export default ImportSignature;
